export const MODAL_MESSAGES = {
  VERIFY: {
    TITLE: "Verifikasi Lembaga",
    DESCRIPTION: "Apakah Anda yakin ingin memverifikasi lembaga ini?",
    SUCCESS: "Lembaga berhasil diverifikasi",
    ERROR: "Gagal memverifikasi lembaga",
  },
  REVISE: {
    TITLE: "Revisi Lembaga",
    DESCRIPTION: "Masukkan catatan revisi untuk lembaga ini",
    REASON_LABEL: "Catatan Revisi",
    REASON_PLACEHOLDER: "Masukkan catatan revisi...",
    REASON_REQUIRED: "Catatan revisi harus diisi",
    SUCCESS: "Permintaan revisi berhasil dikirim",
    ERROR: "Gagal mengirim permintaan revisi",
  },
  REJECT: {
    TITLE: "Tolak Lembaga",
    DESCRIPTION: "Apakah Anda yakin ingin menolak lembaga ini?",
    REASON_LABEL: "Alasan Penolakan",
    REASON_PLACEHOLDER: "Masukkan alasan penolakan...",
    REASON_REQUIRED: "Alasan penolakan harus diisi",
    SUCCESS: "Lembaga berhasil ditolak",
    ERROR: "Gagal menolak lembaga",
  },
};

export const VERIFICATION_STATUS_OPTIONS = [
  { label: "Menunggu Verifikasi", value: "pending" },
  { label: "Diterima", value: "accepted" },
  { label: "Direvisi", value: "revised" },
  { label: "Ditolak", value: "rejected" },
];

